import { render } from "./AntifraudList.vue?vue&type=template&id=6cae1e1c&scoped=true"
import script from "./AntifraudList.vue?vue&type=script&lang=js"
export * from "./AntifraudList.vue?vue&type=script&lang=js"

import "./AntifraudList.vue?vue&type=style&index=0&id=6cae1e1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cae1e1c"]])

export default __exports__